export const REQUEST_ERROR_MESSAGE = 'Ошибка сервера';

export const FORM_NAME = 'cost';

export const REQUIRED_FIELDS = ['cost'];
